<!-- Example Questions Section -->
<div class="example-questions-wrapper" *ngIf="visible">
    <!-- Header -->
    <div class="example-questions-header">
        <span class="questions-icon">lightbulb</span>
        <h2 class="questions-title">Example Questions</h2>
    </div>

    <!-- Categories Grid -->
    <div class="example-questions-section">
        <!-- Each Category -->
        <div class="question-category" *ngFor="let category of categories">
            <!-- Category Header -->
            <div class="category-header">
                <span class="category-icon" [class]="category.iconClass">{{ category.icon }}</span>
                <h3 class="category-title">{{ category.title }}</h3>
            </div>

            <!-- Questions in Category -->
            <div class="questions-box-group">
                <div class="question-box" 
                     *ngFor="let question of category.questions"
                     (click)="onQuestionClick(question.text)">
                    {{ question.text }}
                </div>
            </div>
        </div>
    </div>
</div>
